import _ from 'lodash';

export function setterReducer({ set, reset = null, initial = null, presets = null, custom = null, allowed = null }) {
  let resetActions;
  if (_.isString(reset)) {
    // turn into an array
    resetActions = [reset];
  } else if (_.isArray(reset)) {
    resetActions = reset;
  }
  return (state = initial, action = {}) => {
    const { type, payload } = action;

    if (type === set) {
      return payload;
    }

    if (resetActions && _.includes(resetActions, type)) {
      return initial;
    }

    if (presets && type === presets.action) {
      return presets.values[payload.preset];
    }

    if (custom) {
      return custom(state, action);
    }

    if (allowed && _.isArray(allowed)) {
      if (!_.includes(allowed, state)) {
        return initial;
      }
    }

    return state;
  };
}

export function toggleReducer({
  toggle = [],
  set = [],
  unset = [],
  reset = [],
  presets = null,
  initial = false,
  custom = null,
}) {
  const toggleActions = _.isString(toggle) ? [toggle] : toggle;
  const setActions = _.isString(set) ? [set] : set;
  const unsetActions = _.isString(unset) ? [unset] : unset;
  const resetActions = _.isString(reset) ? [reset] : reset;

  return (state = initial, action = {}) => {
    const { type, payload } = action;

    if (_.includes(toggleActions, type)) {
      return !state;
    }
    if (_.includes(setActions, type)) {
      return true;
    }
    if (_.includes(unsetActions, type)) {
      return false;
    }
    if (_.includes(resetActions, type)) {
      return initial;
    }
    if (presets && type === presets.action) {
      return presets.values[payload.preset];
    }
    if (custom) {
      return custom(state, action);
    }

    return state;
  };
}
